export var ApplicationLauncherPosition = {
  right: 'right',
  left: 'left'
};
export var ApplicationLauncherDirection = {
  up: 'up',
  down: 'down'
};